export default __webpack_public_path__ + "static/media/vector-homepage.56659ec1.svg";